/**
 * PhoenixAuthUser
 */

'use strict';
const { getDependencyClass } = require('../../lib/dependencies.js');

// connectedCallback can be called more than once, so prevent running the code repeatedly
let connected = false;

getDependencyClass('phoenix-page').then((pageClass) => {
    class PhoenixAuthUser extends pageClass.PhoenixElement {
        connectedCallback() {
            if (connected) {
                return;
            }
            connected = true;

            this.page = this.closest('phoenix-page');
            this.page.classList.add('is-auth-user-enabled');
            this._handleRGIS();
        }

        _handleRGIS() {
            const self = this;
            var userStatus = window.phxGetLoggedInStatus();
            if (userStatus && userStatus['type'] === 'rgis') {
                self.userId = userStatus['id'];
                self.rgis = userStatus['rgis'];
            }

            if (self.userId) {
                this.classList.add('is-authenticated');
                this.page.classList.add('is-authenticated');
                this._checkEntitlements();
            } else {
                window.isUserEntitled = false;
            }
        }

        _checkEntitlements() {
            // If coming back from a new subscription, the query string will have a token
            // parameter; the endpoint doesn't actually parse it to get the entitlements,
            // but we pass it in the request to bust the cache
            const token = this.query.token,
                tokenStr = token ? `&token=${token}` : '';
            // The new checkEntitlements middleware only supports RGIS-based entitlements
            // checks from Taiga.
            if (!this.rgis) {
                return;
            }
            this.fetchWithBasePath(`/.api/memberships/check-entitlements/${this.userId}${tokenStr}`, {
                headers: { 'x-rgis': this.rgis },
            })
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    } else {
                        // eslint-disable-next-line no-console
                        console.error(response.json());
                    }
                })
                .then((result) => {
                    if (result.entitlements?.length > 0) {
                        document.body.classList.add('is-eligible-for-exclusive-content');
                    }
                    window.isUserEntitled = !!result.entitlements?.length;
                    this._updateBlueconicProfile(window.isUserEntitled);
                });
        }

        _updateBlueconicProfile(isUserEntitled) {
            function update() {
                const profile = window.blueConicClient.profile.getProfile();
                profile.setValue('si_subscriber_status', '' + isUserEntitled);
                window.blueConicClient.profile.updateProfile(this, () => {});
            }
            if (typeof window.blueConicClient === 'undefined') {
                window.addEventListener('onBlueConicLoaded', update, false);
            } else {
                update();
            }
        }
    }
    window.customElements.define('phoenix-auth-user', PhoenixAuthUser);
});
